
import { defineComponent, ref, computed } from 'vue'
import { useRoute } from 'vue-router'
import FormTextInput from '@/components/ui/FormTextInput.vue'
import ButtonDefault from '@/components/ui/ButtonDefault.vue'
import MultiSelect from '@/components/ui/MultiSelect.vue'
import SuccessForm from '@/components/common/TheSuccessForm.vue'
import { BankInfoFormConfiguration } from '@/config/variables'
import { EValidity, checkErrorsReturn } from '@/use/validInput'
import { c4bApi } from '@/api/C4bApi'
import banksList from '@/config/banksList.json'

interface BankInfo {
    ShortName: string
    COMPE: string
}

const initialInputErrors = {
    bankName: [],
    branch: [],
    checkingAccount: [],
}

const initialInputValidationStatus = {
    bankName: EValidity.Undefined,
    branch: EValidity.Undefined,
    checkingAccount: EValidity.Undefined,
}

export default defineComponent({
    components: {
        FormTextInput,
        ButtonDefault,
        MultiSelect,
        SuccessForm,
    },
    props: {
        imageFileName: String,
        altText: String,
    },
    setup() {
        const route = useRoute()
        const hash = route.params.id as string
        const formInfo = ref({
            bankName: '',
            branch: '',
            checkingAccount: '',
            hash: hash
        })
        const inputsErrors = ref(initialInputErrors)
        const inputValidationStatus = ref(initialInputValidationStatus)
        const wasFormSubmitted = ref(false)
        const banksListSum = banksList.map((bank: BankInfo) => {
            return `${bank.COMPE} - ${bank.ShortName}`
        })
        const inputIsInvalid = computed(() => {
            return {
                bankName:
                    inputValidationStatus.value.bankName === EValidity.Invalid,
                branch:
                    inputValidationStatus.value.branch === EValidity.Invalid,
                checkingAccount:
                    inputValidationStatus.value.checkingAccount ===
                    EValidity.Invalid,
            }
        })

        /** Funcao que faz o request dos dados bancarios para o servidor */
        const handleSubmit = async () => {
            try {
                
                await c4bApi.bankInfo().post(formInfo.value)
                window.location.href = '/contractSign/' + hash
            } catch (error: any) {
                const newStatus = { ...initialInputValidationStatus }
                const newErrors = { ...initialInputErrors }

                if (!checkErrorsReturn(error.response.data.errors.BankName)) {
                    newErrors.bankName = error.response.data.errors.BankName
                    newStatus.bankName = EValidity.Invalid
                }
                if (!checkErrorsReturn(error.response.data.errors.Branch)) {
                    newErrors.branch = error.response.data.errors.Branch
                    newStatus.branch = EValidity.Invalid
                }
                if (
                    !checkErrorsReturn(
                        error.response.data.errors.CheckingAccount
                    )
                ) {
                    newErrors.checkingAccount =
                        error.response.data.errors.CheckingAccount
                    newStatus.checkingAccount = EValidity.Invalid
                }
                inputValidationStatus.value = newStatus
                inputsErrors.value = newErrors
            }
        }
        return {
            formInfo,
            inputValidationStatus,
            inputIsInvalid,
            inputsErrors,
            banksListSum,
            wasFormSubmitted,
            BankInfoFormConfiguration,
            handleSubmit
        }
    },
})
